<template>
	<div class="mixed_content">
		<div class="container"></div>
	</div>
</template>

<script>
export default {
	props: {
		mixed_content: {},
	},

	computed: {
		parsedMixedContent() {
			if (this.mixed_content) {
				return JSON.parse(this.mixed_content);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';
</style>
